import {
  ADD_GAME_SETTING,
  DESTROY_GAME_SETTING,
  UPDATE_GAME_SETTING,
} from '../constants/action-types'
import { convertStateListToObject } from '../lib/utils'

const initialState = {
  list: INITIAL.game_settings || [],
  settings: convertStateListToObject(INITIAL.game_settings || [], "key"),
}

export default (state = initialState, action) => {
  const gameSettings = Object.values(state.list)
  const initialGameSettings = [...gameSettings]

  switch(action.type) {
    case ADD_GAME_SETTING:
      const gameSettingId = action.payload.id
      const gameSettingData = action.payload

      initialGameSettings.push(gameSettingData)

      const list = {
        ...state.list,
        [gameSettingId]: gameSettingData
      }
      return {
        ...state,
        list: list,
        settings: convertStateListToObject(list, "key"),
      }
    case UPDATE_GAME_SETTING: {
      const gameSettingId = action.payload.id
      const gameSettingData = action.payload

      let gameSettings = {...state.list}
      gameSettings[gameSettingId] = gameSettingData

      return {
        ...state,
        list: gameSettings,
        settings: convertStateListToObject(gameSettings, "key"),
      }
    }
    case DESTROY_GAME_SETTING:
      const { [action.payload.id]: _, ...withoutGameSetting } = state.list

      return {
        ...state,
        list: withoutGameSetting,
        settings: convertStateListToObject(withoutGameSetting, "key"),
      }
    default:
      return state
  }
}